import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.span`
  //font-family: Bolton-Bold;
  text-decoration: underline;
`;

export default function Underline({ children }) {
  return <Wrapper>{children}</Wrapper>;
}
